import { Button, Input } from "antd";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { post } from "../../../../services/services";
import { ApiURL } from "../../../../services/apiConstants";
import { ErrorToast, ShowInputError, SuccessToast } from "../../../../widgets/AppToast";

const { TextArea } = Input;

function AuxiRemarks() {
  const { eng_log_basic_id } = useParams();
  const [staffDashboard, setStaffDashboard] = useState({});
  const [loader, setLoader] = useState(false);
  const [errors, setErrors] = useState({});
  const [freeText, setFreeText] = useState("");
  const [isUpdateMode, setIsUpdateMode] = useState(false);

  // Fetch staff_dashboard from localStorage
  useEffect(() => {
    const staffData = localStorage.getItem("staff_dashboard");
    const parsedData = JSON.parse(staffData);
    if (parsedData) {
      setStaffDashboard(parsedData);
    }
  }, []);

  useEffect(() => {
    const staffData = localStorage.getItem("staff_dashboard");
    const parsedData = JSON.parse(staffData);
    if (parsedData) {
      setStaffDashboard(parsedData);
    }
  }, []);

  // Run AUXI_REMARKS_DETAILS only after staffDashboard is loaded
  useEffect(() => {
    if (
      staffDashboard &&
      Array.isArray(staffDashboard.voyage_details) &&
      staffDashboard.voyage_details.length > 0
    ) {
      const voyage_id = staffDashboard.voyage_details[0].id;
      AUXI_REMARKS_DETAILS(voyage_id);
    }
  }, [staffDashboard]);

  const AUXI_REMARKS_DETAILS = async (voyage_id) => {
    const formData = new FormData();
    formData.append("eng_log_basic_id", Number(eng_log_basic_id) || 0);
    formData.append("voyage_id", voyage_id);
    try {
      const res = await post(ApiURL.get_auxi_remarks_details, formData);
      if (res?.status === true && res?.remark_data) {
        setFreeText(res?.remark_data?.auxi_remark || "");
        setIsUpdateMode(res?.remark_data?.complete_status || false);
      }
    } catch (err) {
      // Optional error toast
    }
  };

  const handleSaveOrUpdate = async () => {
    setLoader(true);
    const formData = new FormData();
    formData.append("voyage_id", staffDashboard?.voyage_details?.[0]?.id || "");
    formData.append("eng_log_basic_id", Number(eng_log_basic_id) || 0);
    formData.append("auxi_remark", freeText || "");

    const apiUrl = isUpdateMode ? ApiURL.get_auxi_remarks_details : ApiURL.add_auxi_remarks;

    try {
      const res = await post(apiUrl, formData);
      if (res?.status === true) {
        SuccessToast(isUpdateMode ? "Updated successfully" : "Saved successfully", res.message);
        setErrors({});
        setIsUpdateMode(true);
      } else {
        ErrorToast("Error", res.message);
        setErrors(res.errors || {});
      }
    } catch (err) {
      ErrorToast("Error", "Something went wrong.");
    }
    setLoader(false);
  };

  return (
    <div className="white-container">
      <div className="row">
        <div className="col-12">
          <div className="input-box">
            <label>Auxiliary Machinery Remarks</label>
            <TextArea
              rows={6}
              placeholder="Auxiliary Machinery comments"
              maxLength={1000}
              // disabled={submitStatus}
              value={freeText}
              onChange={(e) => setFreeText(e.target.value)}
            />
            {errors.auxilary_remarks && <ShowInputError errorMessage={errors.auxilary_remarks} />}
          </div>
        </div>
      </div>

      {
        <Button type="primary" loading={loader} onClick={handleSaveOrUpdate}>
          {isUpdateMode ? "Update" : "Save"}
        </Button>
      }
    </div>
  );
}

export default AuxiRemarks;
